var map = {
	"./classroom_1.jpg": "j1E4",
	"./classroom_2.jpg": "rVl7",
	"./classroom_3.jpg": "JXX0",
	"./classroom_4.jpg": "YLKd",
	"./classroom_5.jpg": "etcM",
	"./hall_1.jpg": "jGwn",
	"./hall_2.jpg": "0Wki",
	"./hall_3.jpg": "+D3j",
	"./hall_4.jpg": "qzeS",
	"./hall_5.jpg": "di9r",
	"./living_1.jpg": "qJt7",
	"./living_2.jpg": "bcFy",
	"./living_3.jpg": "x20y",
	"./living_4.jpg": "b3O6",
	"./living_5.jpg": "/Evi",
	"./meeting_1.jpg": "Y1R+",
	"./meeting_2.jpg": "fQv7",
	"./meeting_3.jpg": "6I7x",
	"./meeting_4.jpg": "BDt5",
	"./meeting_5.jpg": "LcKi",
	"./result_ceil.jpg": "xcsS",
	"./result_ceil_angle.jpg": "91J9",
	"./result_ceil_lx.jpg": "ZsCF",
	"./result_ceil_lx_angle.jpg": "hRv+",
	"./result_celling.jpg": "IXwL",
	"./result_desk.jpg": "6yCz",
	"./result_desk_angle.jpg": "Mm0v",
	"./result_desk_lx.jpg": "yDHb",
	"./result_desk_lx_angle.jpg": "LIl5",
	"./result_desktop.jpg": "217F",
	"./theatre_1.jpg": "1KOR",
	"./theatre_2.jpg": "ga2p",
	"./theatre_3.jpg": "HAQE",
	"./theatre_4.jpg": "aru1",
	"./theatre_5.jpg": "qRYL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Gywi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result ^\.\/.*\.jpg$
// module id = Gywi
// module chunks = 3